import React from "react";
import { chakra, Image } from "@chakra-ui/react";

import styles from "./Styles.module.css";

import users from "assets/users.svg";
import uptime from "assets/uptime.svg";
import server from "assets/server.svg";
import command from "assets/command.svg";

import Header from "components/Header";
import Footer from "components/Footer";

export default function Home() {
  let language = localStorage.getItem("language");
  const newLanguage = require(`language/${language!}.json`);

  return (
    <>
      <Header />
      <chakra.div className={styles.content}>
        <chakra.div marginRight="160px">
          <chakra.p fontSize="25pt" fontWeight="1000">
            {newLanguage.homepage.user.value}
          </chakra.p>
          <chakra.p
            fontSize="16pt"
            fontWeight="500"
            color="#105F80"
            top="-30px"
          >
            {newLanguage.homepage.user.name}
          </chakra.p>
          <chakra.p fontSize="12pt">
            {newLanguage.homepage.user.description}
          </chakra.p>
        </chakra.div>
        <chakra.div>
          <Image src={users} alt="imagem para usuários" width="250px" />
        </chakra.div>
      </chakra.div>
      <chakra.div className={styles.content} background="#031019">
        <chakra.div>
          <Image src={server} alt="imagem para usuários" width="300px" />
        </chakra.div>

        <chakra.div marginLeft="160px">
          <chakra.p fontSize="25pt" fontWeight="1000">
            {newLanguage.homepage.server.value}
          </chakra.p>
          <chakra.p
            fontSize="16pt"
            fontWeight="500"
            color="#105F80"
            top="-30px"
          >
            {newLanguage.homepage.server.name}
          </chakra.p>
          <chakra.p fontSize="12pt">
            {newLanguage.homepage.server.description}
          </chakra.p>
        </chakra.div>
      </chakra.div>

      <chakra.div className={styles.content}>
        <chakra.div marginRight="160px">
          <chakra.p fontSize="25pt" fontWeight="1000">
            {newLanguage.homepage.uptime.value}
          </chakra.p>
          <chakra.p
            fontSize="16pt"
            fontWeight="500"
            color="#105F80"
            top="-30px"
          >
            {newLanguage.homepage.uptime.name}
          </chakra.p>
          <chakra.p fontSize="12pt">
            {newLanguage.homepage.uptime.description}
          </chakra.p>
        </chakra.div>
        <chakra.div>
          <Image src={uptime} alt="imagem para usuários" width="300px" />
        </chakra.div>
      </chakra.div>
      <chakra.div className={styles.content} background="#031019">
        <chakra.div>
          <Image src={command} alt="imagem para usuários" width="300px" />
        </chakra.div>

        <chakra.div marginLeft="160px">
          <chakra.p fontSize="25pt" fontWeight="1000">
            {newLanguage.homepage.commands.value}
          </chakra.p>
          <chakra.p
            fontSize="16pt"
            fontWeight="500"
            color="#105F80"
            top="-30px"
          >
            {newLanguage.homepage.commands.name}
          </chakra.p>
          <chakra.p fontSize="12pt">
            {newLanguage.homepage.commands.description}
          </chakra.p>
        </chakra.div>
      </chakra.div>
      <Footer />
    </>
  );
}
